var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.87068 11.2383L13.1132 17.6636C13.2157 17.7702 13.3377 17.8548 13.4721 17.9125C13.6065 17.9703 13.7506 18 13.8962 18C14.0418 18 14.186 17.9703 14.3204 17.9125C14.4548 17.8548 14.5768 17.7702 14.6793 17.6636C14.8847 17.4505 15 17.1623 15 16.8619C15 16.5614 14.8847 16.2732 14.6793 16.0601L9.21988 10.374L14.6793 4.74466C14.8847 4.53159 15 4.24335 15 3.94291C15 3.64247 14.8847 3.35424 14.6793 3.14116C14.5771 3.03371 14.4553 2.94822 14.3209 2.88966C14.1865 2.8311 14.0421 2.80062 13.8962 2.8C13.7503 2.80062 13.6059 2.8311 13.4715 2.88966C13.3371 2.94822 13.2153 3.03371 13.1132 3.14116L6.87068 9.56652C6.75873 9.67301 6.66939 9.80226 6.60828 9.94612C6.54717 10.09 6.51562 10.2453 6.51562 10.4024C6.51562 10.5594 6.54717 10.7148 6.60828 10.8587C6.66939 11.0025 6.75873 11.1318 6.87068 11.2383Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.4d383f6891f8cf3278525631abcac9d8.svg";
export { ForwardRef as ReactComponent };